/* PayPal "Pay Later" messaging banner.
   Reusable across product page and cart-drawer: rendered by the <paypal-pay-later>
   custom element which loads the messaging SDK under its own `paypalMessaging`
   namespace so it never clobbers the store's checkout-button `paypal` global.
   Renders per-instance, so multiple banners (product price + cart total) coexist.
   Appearance is not set here: the SDK natively reads data-pp-style-* attributes
   off the render container (they take precedence over JS options), so style is
   configured per-instance on the <paypal-pay-later> tag — see
   snippets/paypal-pay-later.liquid for the supported set and the attributes to avoid. */
const PaypalPayLater = class extends HTMLElement {
  static get observedAttributes() {
    return ['amount'];
  }

  connectedCallback() {
    PaypalPayLater.loadSdk(this.getAttribute('currency'));
    this.renderMessage();

    if (this.hasAttribute('watch-variant')) {
      this.onVariantChange = (event) => {
        const variant = event.detail && event.detail.variant;
        if (variant && typeof variant.price === 'number') {
          this.setAttribute('amount', (variant.price / 100).toFixed(2));
        }
      };
      document.addEventListener('on:variant:change', this.onVariantChange);
    }
  }

  disconnectedCallback() {
    if (this.onVariantChange) {
      document.removeEventListener('on:variant:change', this.onVariantChange);
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    // Skip the initial upgrade (oldValue === null); connectedCallback owns the first render.
    if (name === 'amount' && oldValue !== null && oldValue !== newValue && this.isConnected) {
      this.renderMessage();
    }
  }

  renderMessage() {
    PaypalPayLater.whenReady(() => {
      const amount = parseFloat(this.getAttribute('amount'));
      if (!amount) return;
      this.innerHTML = '';
      window[PaypalPayLater.NS]
        .Messages({
          amount,
          currency: this.getAttribute('currency') || undefined,
          placement: this.getAttribute('placement') || 'product',
        })
        .render(this);
    });
  }
};

PaypalPayLater.NS = 'paypalMessaging';

PaypalPayLater.loadSdk = (currency) => {
  if (document.querySelector('script[data-paypal-messaging-sdk]')) return;
  const sdk = document.createElement('script');
  sdk.async = true;
  sdk.setAttribute('data-paypal-messaging-sdk', '');
  sdk.setAttribute('data-namespace', PaypalPayLater.NS);
  sdk.src =
    'https://www.paypal.com/sdk/js?client-id=AbX5vD6I6jHvFyqzsLZ1H19yE9t446eQzsq0IN6L_EdUBmQZY-OkGIOCysXfXAuFmxJiR6E7vAXQJbcq&components=messages&currency=' +
    encodeURIComponent(currency || 'EUR') +
    '&locale=it_IT';
  document.head.appendChild(sdk);
};

PaypalPayLater.whenReady = (callback, tries) => {
  const attempts = tries || 0;
  const ns = window[PaypalPayLater.NS];
  if (ns && ns.Messages) {
    callback();
    return;
  }
  if (attempts > 100) return;
  setTimeout(() => PaypalPayLater.whenReady(callback, attempts + 1), 100);
};

window.customElements.define('paypal-pay-later', PaypalPayLater);
